import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiResponse } from '../../shared/models/api-response';
import { StateService } from '../../shared/services/state.service';
import { ChaptersService } from '../chapters.service';
import { ChapterInfo } from '../chapters.models';
import { SessionService } from '../../shared/services/session.service';
import * as $ from "jquery";


@Component({
  selector: 'app-activation',
  templateUrl: './activation.component.html',
  styleUrls: ['./activation.component.scss']
})

export class ActivationComponent implements OnInit {
  public mydevice: string = "";
  public bloburl: string;
  licenseId: string;
  chapterName: string;
  str: any;
  deleteRow: any;
  chapters: ChapterInfo[];
  errorMessage: string;
  loading: boolean = true;
  submitloading = false;
  maximumRowsLeftCol: any = 0;
  maximumRowsRightCol: any = 0;

  constructor(private route: ActivatedRoute,
    private sessionService: SessionService,
    private chapterService: ChaptersService,
    private router: Router,
    private stateService: StateService) { }


 
  onSave() {
     this.submitloading = true;
      $(".round").addClass("round_disable");
      var element = <HTMLInputElement>document.getElementById("submit");
      element.setAttribute("disabled", "");
      element.setAttribute("style", "opacity:0.3");
      element.setAttribute("style", "cursor:default");
    this.chapterService.UpdateChapters(this.licenseId, this.chapters).subscribe((data: ApiResponse<boolean>) => {
      if (data.success && data.payload) {
        this.submitloading = false;
        $("#tick").show();
        $(".round").removeClass("round_disable");
      } else {
        this.errorMessage = `Fel vid uppdatering av kapitel, fel: ${data.errorMessage}`;
      }
    });
  }

  nameList(current_name) {

    var arr_names = [
      "Kapitel 1 – Flickan och cirkushunden",
      "Kapitel 2 – Strömlöst hos Charlie Knapp",
      "Kapitel 3 – Kejsarpingviner",
      "Kapitel 4 – Flöjtspelaren i Hameln",
      "Kapitel 5 – Dikter",
      "Kapitel 6 – Djur i regnskogen",
      "Kapitel 7 – Hemligt – Jördis hjärta Harry",
      "Kapitel 8 – Stenåldern",
      "Kapitel 9 – Kompismagasinet",
      "Kapitel 10 – Kackerlackan",
      "Kapitel 11 – Renata – en äventyrare",
      "Kapitel 12 – Experimentera mera",
      "Kapitel 13 – Max och den magiska penseln",
      "Kapitel 14 – Blött, sött och salt",
      "Kapitel 15 – Den gamla herrgården"

    ];
    var assign_names = ["ContentType1_1", "ContentType1_2", "ContentType1_3", "ContentType1_4", "ContentType1_5",
      "ContentType1_6", "ContentType1_7", "ContentType1_8", "ContentType1_9", "ContentType1_10", "ContentType1_11",
      "ContentType1_12", "ContentType1_13", "ContentType1_14", "ContentType1_15"];
    var index_no = assign_names.indexOf(current_name);
    var name_of_chapter = "";
    if (index_no >= 0) {
      name_of_chapter = arr_names[index_no];
    }
    else {
      name_of_chapter = current_name;
    }
    return name_of_chapter;
  }
  tickhide() {
    this.submitloading = false;
    $("#tick").hide();
    var element = <HTMLInputElement>document.getElementById("submit");
    element.removeAttribute("disabled");
    element.setAttribute("style", "opacity:1");
  }

 
  getChapters(studentLicenseId: string): void {
    this.chapterService.getAvailableChapters(studentLicenseId).subscribe((data: ApiResponse<ChapterInfo[]>) => {
      if (data.success) {
       
        this.chapters = data.payload;
        this.chapters.length = 15;
        var total_records = this.chapters.length;
        var quotient = Math.floor(total_records / 2);
        var remainder = total_records % 2;
        this.maximumRowsLeftCol = quotient + remainder;
        this.maximumRowsRightCol = quotient;

      }
      else {
        this.errorMessage = `Fel vid hämtning av kapitel, fel: ${data.errorMessage}`;
      }
      this.loading = false;
    });
  }
  ngOnInit() {
    var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var userAgent = navigator.userAgent.toLowerCase();
    var android_dev = userAgent.indexOf("android") > -1;
    var chrome_browser = userAgent.indexOf("chrome") > -1;
    var samsung_browser = userAgent.indexOf("samsung") > -1;
    if (isIOS) {
      this.mydevice = "ipad";
    }
    else if (android_dev) {
      this.mydevice = "android";

      if (samsung_browser) {
        this.mydevice = this.mydevice + "_samsung";
      }
      else if (chrome_browser) {
        this.mydevice = this.mydevice + "_chrome";

      }
      var body = document.body;
      body.classList.add(this.mydevice);
    }
    this.bloburl = this.sessionService.bloburl;
    $("#tick").hide();
    var element = <HTMLInputElement>document.getElementById("submit");
    element.setAttribute("disabled","");
    element.setAttribute("style", "opacity:0.3");
    element.setAttribute("style", "cursor:default");
    this.licenseId = this.stateService.getLicenseId();

    if (!this.licenseId) {
      this.errorMessage = "Saknar licenseId"
    } else {
      this.getChapters(this.licenseId);
    }

  }

}
